<template>
  <div class="ie-manage">
    <!-- 页头 -->
    <div class="page-header">
      <div>
        <h2 style="margin-top: 0;">
          IE 信息管理
          <span class="h2-pt">Gestão de IE</span>
        </h2>
        <div class="desc">
          <span>维护受监控的开票主体：UF、CNPJ、IE、公司名称、城市、双轨状态</span>
          <span class="desc-pt">
            Gerencie as entidades emissoras monitoradas: UF, CNPJ, IE, razão social, cidade e status das duas trilhas
          </span>
        </div>
      </div>
      <div class="right">
        <el-button size="small" @click="handleExport">
          <bi-label zh="导出" pt="Exportar" inline />
        </el-button>
        <el-button
          size="small" :loading="checking" :disabled="checking"
          @click="handleAllCheck"
        >
          <bi-label zh="全部检查" pt="Verificar Tudo" inline />
        </el-button>
        <el-button size="small" type="primary" @click="openAdd">
          + <bi-label zh="新增 IE" pt="Nova IE" inline />
        </el-button>
      </div>
    </div>

    <!-- 筛选 -->
    <el-card class="filter-card" shadow="never">
      <el-form
        :model="searchParam" label-position="top"
        size="small"
      >
        <el-row :gutter="16">
          <!-- 关键词：label 处下拉切换字段（同 CTE「发票密钥 / 运单号」），默认 CNPJ -->
          <el-col :span="6">
            <el-form-item class="kw-search">
              <template slot="label">
                <el-select v-model="searchParam.params.kwType">
                  <el-option
                    v-for="o in kwTypeOptions" :key="o.value" :label="o.label + (o.labelPt ? ' / ' + o.labelPt : '')"
                    :value="o.value"
                  />
                </el-select>
              </template>
              <el-input
                v-model="searchParam.params.kw"
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 4 }"
                :placeholder="$t('GlobalSetObj.CanBeEnteredMultiple2000')"
              />
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <template slot="label">
                <bi-label zh="UF" inline />
              </template>
              <el-select
                v-model="searchParam.params.uf"
                style="width: 100%"
                multiple
                collapse-tags
                clearable
                filterable
                placeholder="全部 / Todos"
              >
                <el-option
                  v-for="uf in ufOptions" :key="uf.id" :label="uf.label"
                  :value="uf.label"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <!--<el-col :span="6">
            <el-form-item>
              <template slot="label">
                <bi-label zh="主体状态" pt="Status da Entidade" inline />
              </template>
              <el-select v-model="searchParam.params.overallStatus" placeholder="全部 / Todos" style="width: 100%">
                <el-option
                  v-for="o in statusOptions" :key="o.value" :label="o.label + ' / ' + o.labelPt"
                  :value="o.value"
                />
              </el-select>
            </el-form-item>
          </el-col>-->
          <el-col :span="6">
            <el-form-item>
              <template slot="label">
                <bi-label zh="税务状态" pt="Status Fiscal" inline />
              </template>
              <el-select
                v-model="searchParam.params.taxStatus" clearable placeholder="全部 / Todos"
                style="width: 100%"
              >
                <el-option
                  v-for="o in taxOptions" :key="o.value" :label="o.label + ' / ' + o.labelPt"
                  :value="o.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <template slot="label">
                <bi-label zh="系统配置" pt="Config. Sistema" inline />
              </template>
              <el-select
                v-model="searchParam.params.sysStatus" clearable placeholder="全部 / Todos"
                style="width: 100%"
              >
                <el-option
                  v-for="o in sysOptions" :key="o.value" :label="o.label + ' / ' + o.labelPt"
                  :value="o.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item>
              <template slot="label">
                <bi-label zh="启用监控" pt="Ativar Monitoramento" inline />
              </template>
              <el-select
                v-model="searchParam.params.enable" clearable placeholder="全部 / Todos"
                style="width: 100%"
              >
                <el-option
                  v-for="o in enableOptions" :key="o.value" :label="o.label + ' / ' + o.labelPt"
                  :value="o.value"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item class="filter-btns">
              <template slot="label">
                <span class="ph-label">&nbsp;</span>
              </template>
              <el-button size="small" type="primary" @click="applyFilter">
                <bi-label zh="查询" pt="Consultar" inline />
              </el-button>
              <el-button size="small" @click="resetFilter">
                <bi-label zh="重置" pt="Redefinir" inline />
              </el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="tableLoading"
        :data="pagedRows"
        border
        size="mini"
        row-key="id"
        style="width: 100%"
      >
        <el-table-column type="selection" width="44" />
        <el-table-column width="60">
          <template slot="header">
            <bi-label zh="UF" />
          </template>
          <template slot-scope="{ row }"><strong>{{ row.uf }}</strong></template>
        </el-table-column>
        <el-table-column width="170" class-name="cell-num">
          <template slot="header">
            <bi-label zh="CNPJ" />
          </template>
          <template slot-scope="{ row }">{{ fmtCnpj(row.cnpj) }}</template>
        </el-table-column>
        <el-table-column width="160" class-name="cell-num">
          <template slot="header">
            <bi-label zh="IE" />
          </template>
          <template slot-scope="{ row }">{{ row.ie }}</template>
        </el-table-column>
        <el-table-column min-width="200" show-overflow-tooltip>
          <template slot="header">
            <bi-label zh="公司名称" pt="Razão Social" />
          </template>
          <template slot-scope="{ row }">{{ row.companyName }}</template>
        </el-table-column>
        <el-table-column width="110">
          <template slot="header">
            <bi-label zh="城市" pt="Cidade" />
          </template>
          <template slot-scope="{ row }">{{ row.city }}</template>
        </el-table-column>
        <el-table-column width="170">
          <template slot="header">
            <bi-label zh="有效期限" pt="Validade" />
          </template>
          <template slot-scope="{ row }">
            <span v-if="!row.validade" class="vd-empty">
              <!-- validade 为空即未录入 -->
              未录入<span class="vd-pt">/ Não Registrado</span>
            </span>
            <span v-else :class="validadeCls(row)">
              {{ row.validade }}
              <span class="vd-days">· {{ validadeText(row) }}</span>
              <span class="vd-pt">{{ validadeTextPt(row) }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="170">
          <template slot="header">
            <bi-label zh="税务状态" pt="Status Fiscal" />
          </template>
          <template slot-scope="{ row }">
            <span class="tag" :class="taxTagCls(row.taxStatus)">
              <span class="dot" />{{ taxText(row.taxStatus) }}
              <span class="tag-pt">/ {{ taxTextPt(row.taxStatus) }}</span>
            </span>
          </template>
        </el-table-column>
        <el-table-column width="200">
          <template slot="header">
            <bi-label zh="系统配置 · 操作" pt="Config. Sistema · Ação" />
          </template>
          <template slot-scope="{ row }">
            <div class="sys-cell">
              <span class="tag" :class="row.sysStatus === 1 ? 'tag-info' : 'tag-err'">
                <span class="dot" />{{ sysText(row.sysStatus) }}
                <span class="tag-pt">/ {{ sysTextPt(row.sysStatus) }}</span>
              </span>
              <el-button
                size="mini" type="primary"
                @click="openSysop(row)"
              >
                检索代码配置<span class="sys-pt">/ Buscar Config.</span>
              </el-button>
            </div>
          </template>
        </el-table-column>
        <el-table-column width="150" class-name="cell-num">
          <template slot="header">
            <bi-label zh="最后检查时间" pt="Última Verificação" />
          </template>
          <template slot-scope="{ row }">{{ fmtStamp(row.lastCheckTime) }}</template>
        </el-table-column>
        <el-table-column width="72" align="center" fixed="right">
          <template slot="header">
            <bi-label zh="启用" pt="Ativação" />
          </template>
          <template slot-scope="{ row }">
            <toggle-switch
              :value="row.enable === 1"
              on-text="启用 / Ativado"
              off-text="停用 / Desativado"
              @click="handleToggleEnable(row)"
            />
          </template>
        </el-table-column>
        <el-table-column width="230" fixed="right">
          <template slot="header">
            <bi-label zh="操作" pt="Ações" />
          </template>
          <template slot-scope="{ row }">
            <div class="act-group">
              <a class="act-view" @click="handleView(row)">
                查看<span class="act-pt">/ Ver</span>
              </a>
              <a class="act-view" @click="handleQuery(row)">
                查询<span class="act-pt">/ Consultar</span>
              </a>
              <a :class="row.enable === 1 ? 'act-edit disabled' : 'act-edit'" @click="handleEdit(row)">
                编辑<span class="act-pt">/ Editar</span>
              </a>
            </div>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页：共 N 条 + 每页条数 + 翻页 + 前往页 -->
      <div class="pagination">
        <el-pagination
          :current-page.sync="searchParam.pageNumber"
          :page-size.sync="searchParam.pageSize"
          :page-sizes="[10, 20, 50]"
          :total="total"
          layout="slot, sizes, prev, pager, next, jumper"
          class="ie-pagination"
          @current-change="handlePageChange"
          @size-change="handleSizeChange"
        >
          <span class="pb-total">
            共 {{ total }} 条<span class="pb-pt">/ Total: {{ total }} registros</span>
          </span>
        </el-pagination>
      </div>
    </el-card>

    <!-- 新增弹窗 -->
    <ie-form-dialog
      :visible.sync="formVisible"
      :mode="formMode"
      :row="currentRow"
      :state-list="stateList"
      @save="handleSave"
    />
    <!--查看代码-->
    <sysop-dialog
      :visible.sync="sysopVisible"
      :row="currentRow"
      @updated="handleSysopUpdated"
    />
    <!--启用、禁用确认弹窗-->
    <confirm-dialog
      :visible.sync="confirmVisible"
      :title="confirmOpts.title"
      :title-pt="confirmOpts.titlePt"
      :subtitle="confirmOpts.subtitle"
      :desc="confirmOpts.desc"
      :desc-pt="confirmOpts.descPt"
      :ok-text="confirmOpts.okText"
      :ok-text-pt="confirmOpts.okTextPt"
      :kind="confirmOpts.kind"
      @confirm="confirmOpts.onOk"
    />
    <!--打开详情弹窗：只展示详情接口返回的那条记录（detail），不回退列表数据-->
    <uf-detail-drawer
      :id="detailId"
      :visible.sync="detailVisible"
      :uf="detailUf"
      :detail="detailRow"
      :change-log="detailChangeLog"
      @check="handleQueryByUf"
    />
  </div>
</template>

<script>
import BiLabel from './BiLabel';
import IeFormDialog from './IeFormDialog';
import SysopDialog from './SysopDialog';
import ConfirmDialog from './ConfirmDialog';
import UfDetailDrawer from './UfDetailDrawer';
import ToggleSwitch from './ToggleSwitch';
// 列表与写操作数据全部来自接口，接口未通 / 请求失败时保持空态，不回退假数据
import {
  TAX_LABEL,
  SYS_LABEL,
  daysLeft,
  fmtCnpj,
  cnpjDigits
} from '../mock';
import {
  getInvoiceSubjectStatusMonitorIE,
  getInvoiceSubjectStatusMonitorIEDetail,
  getInvoiceSubjectStatusMonitorLogList,
  getInvoiceSubjectStatusMonitorIEAdd,
  getInvoiceSubjectStatusMonitorIEUpdate,
  getInvoiceSubjectStatusMonitorIEUpdateStatus,
  getInvoiceSubjectStatusMonitorIECheck,
  getInvoiceSubjectStatusMonitorIEBatchCheck, getInvoiceSubjectStatusMonitorIEExport
} from '@/api/invoiceCenter';
import { goResourceTaskList } from '@/utils/goExportList';

export default {
  name: 'IeManagement',
  components: { BiLabel, ToggleSwitch, IeFormDialog, SysopDialog, ConfirmDialog, UfDetailDrawer },
  props: {
    // 到期提醒提前天数：来自告警配置，决定"剩 N 天"何时标为预警（橙）
    expireWarnDays: { type: Number, default: 0 },
    stateList: { type: Array, default: () => [] },
    // 看板 KPI 联动：挂载时即按该主体状态预筛，避免「默认查询 + prefilter」连发两次请求
    prefilterStatus: { type: Object, default: () => {
      return {
        type: null,
        status: null
      };
    } }
  },
  data() {
    return {
      // 表格数据来自分页接口；接口未通 / 请求失败时保持空态，不回退假数据
      rows: [],
      // UF 下拉选项：静态字典（巴西 27 州），不是业务数据
      ufOptions: this.stateList,
      // 抽屉「近期变更」：按 UF 查变更日志接口取最近几条，接口失败时留空
      detailChangeLog: [],
      searchParam: {
        pageSize: 10,
        pageNumber: 1,
        // params 键名与接口请求参数一致（uf / keyword / overallStatus / taxStatus / sysStatus / enable）
        // 其中 keyword 对应多行输入的 kw，kwType 仅用于本地兜底过滤
        params: {
          kwType: 'cnpj',
          kw: '',
          uf: [],
          overallStatus: null,
          taxStatus: null,
          sysStatus: null,
          enable: null
        }
      },
      total: 0,
      tableLoading: false,
      pagedRows: [],
      // 关键词字段（对应接口 keyword 匹配的 CNPJ / IE / 公司名，仅用于本地兜底过滤）
      kwTypeOptions: [
        { value: 'cnpj', label: 'CNPJ', labelPt: '' },
        { value: 'ie', label: 'IE', labelPt: '' },
        { value: 'companyName', label: '公司名称', labelPt: 'Razão Social' }
      ],
      // 综合状态 overallStatus：1正常 2警告 3异常 4停用
      statusOptions: [
        // { value: null, label: '全部', labelPt: 'Todos' },
        { value: 1, label: '正常', labelPt: 'Normal' },
        { value: 2, label: '警告', labelPt: 'Aviso' },
        { value: 3, label: '异常', labelPt: 'Exceção' },
        { value: 4, label: '停用', labelPt: 'Desativado' }
      ],
      // 税务状态 taxStatus：1有效 2无效 3未知 4未录入
      taxOptions: [
        // { value: null, label: '全部', labelPt: 'Todos' },
        { value: 1, label: '有效', labelPt: 'Válida' },
        { value: 2, label: '无效', labelPt: 'Inválida' },
        { value: 3, label: '未知', labelPt: 'Desconhecido' }
        // { value: 4, label: '未录入', labelPt: 'Não Registrado' }
      ],
      // 系统配置状态 sysStatus：1已配置 2未配置
      sysOptions: [
        // { value: null, label: '全部', labelPt: 'Todos' },
        { value: 1, label: '已配置', labelPt: 'Configurado' },
        { value: 2, label: '未配置', labelPt: 'Não Configurado' }
      ],
      // 启用状态 enable：0停用 1启用
      enableOptions: [
        // { value: null, label: '全部', labelPt: 'Todos' },
        { value: 1, label: '启用', labelPt: 'Ativado' },
        { value: 0, label: '停用', labelPt: 'Desativado' }
      ],
      formVisible: false,
      formMode: 'add',
      sysopVisible: false,
      detailVisible: false,
      detailUf: '',
      detailId: null,
      // 详情接口返回的单条记录，抽屉唯一数据源；接口失败时不打开抽屉
      detailRow: null,
      currentRow: null,
      confirmVisible: false,
      confirmOpts: {
        title: '', titlePt: '', subtitle: '', desc: '', descPt: '', okText: '确认', okTextPt: 'Confirmar', kind: 'ok', onOk: () => {}
      },
      checking: false,
      // 列表请求序号：只采用最后一次请求的结果，避免并发请求返回顺序不定导致数据被旧结果覆盖
      reqSeq: 0
    };
  },
  mounted() {
    // 看板 KPI 联动跳转：挂载时就带预筛条件，只发一次请求；否则按默认条件查一次
    if (this.prefilterStatus.status) {
      if (this.prefilterStatus.type === 1) {
        this.searchParam.params.enable = this.prefilterStatus.status;
      } else {
        this.searchParam.params.overallStatus = this.prefilterStatus;
      }
      this.getTableData();
      return;
    }
    this.getTableData();
  },
  methods: {
    /** 全部检查（A08）：执行期间按钮禁用；成功后刷新列表，并通知状态看板刷新检查时间 */
    handleAllCheck() {
      this.checking = true;
      getInvoiceSubjectStatusMonitorIEBatchCheck().then(res => {
        if (res.code === 200) {
          this.$message.success('全部检查完成 / Verificação concluída');
          this.getTableData();
          // 通知父级：状态看板的 KPI（上次 / 下次检查时间、告警计数）需要同步刷新
          this.$emit('checked');
        }
      }).finally(() => {
        this.checking = false;
      });
    },
    // ============ 接口调用 ============
    /**
     * 统一封装接口调用：失败只打日志并返回 null，由调用方提示
     * @param {string} label 接口名称（仅用于日志）
     * @param {Function} fn 真正的请求函数
     * @returns {Promise<object|null>} 成功返回 res，失败返回 null
     */
    async callApi(label, fn) {
      try {
        return await fn();
      } catch (e) {
        console.error(`[IE 信息管理] ${label} 接口请求失败`, e);
        return null;
      }
    },

    // ============ 筛选 / 分页 ============
    /** 整理分页查询参数（与接口字段一致：uf / keyword / overallStatus / taxStatus / sysStatus / enable） */
    queryConditions() {
      const { kwType, enable, kw, overallStatus, sysStatus, taxStatus, uf } = this.searchParam.params;
      const kws = this.getValue(kw);
      const param = {
        uf: uf || [],
        overallStatus,
        taxStatus,
        sysStatus,
        enable
      };
      param[kwType] = kws.length ? kws : [];
      return param;
    },
    /** 多行关键词 → 去重后的数组（最多 2000 个）；CNPJ 去掉符号后再查询 */
    getValue(value) {
      let arr = [];
      const strip = this.searchParam.params.kwType === 'cnpj';
      if (value && value.length) {
        arr = value.split(/\r?\n/).map(item => (strip ? cnpjDigits(item) : item.replace(/\s+/g, ''))).filter(item => Boolean(item));
        const set = new Set([...arr]);
        arr = [...set].slice(0, 2000); // 去重
      }
      return arr;
    },
    /**
     * 获取列表数据：调分页接口；请求失败时清空列表（空态）并提示，不回退本地数据
     * @returns {Promise<boolean>} 是否成功
     */
    async getTableData() {
      const seq = ++this.reqSeq;
      this.tableLoading = true;
      const param = {
        pageNumber: this.searchParam.pageNumber,
        pageSize: this.searchParam.pageSize,
        params: this.queryConditions()
      };
      const res = await this.callApi('page', () => getInvoiceSubjectStatusMonitorIE(param));
      // 期间又发起了新请求：丢弃本次结果，避免旧响应覆盖新数据
      if (seq !== this.reqSeq) return false;
      const ok = !!(res && res.code === 200 && res.data);
      if (ok) {
        // records 字段与页面展示字段一致，直接使用
        const list = Array.isArray(res.data.records) ? res.data.records : [];
        this.rows = list;
        this.pagedRows = list;
        this.total = typeof res.data.total === 'number' ? res.data.total : list.length;
      } else {
        this.rows = [];
        this.pagedRows = [];
        this.total = 0;
        this.$message.error('列表接口请求失败，请稍后重试 / Falha ao consultar a lista');
      }
      this.tableLoading = false;
      return ok;
    },
    /** 翻页：接口分页，切页时重新查询（不再本地切片） */
    handlePageChange(page) {
      this.searchParam.pageNumber = page;
      this.getTableData();
    },
    /** 切换每页条数：回到第 1 页重新查询 */
    handleSizeChange(size) {
      this.searchParam.pageSize = size;
      this.searchParam.pageNumber = 1;
      this.getTableData();
    },
    /** 表单 → 新增 / 编辑接口参数（字段名与接口一致） */
    toPayload(form) {
      return {
        id: form.id || null,
        uf: form.uf,
        // CNPJ 提交一律去掉符号，只保留数字与字母
        cnpj: cnpjDigits(form.cnpj),
        ie: form.ie,
        tradeName: form.tradeName || '',
        companyName: form.companyName || '',
        logradouro: form.logradouro || '',
        numero: form.numero || '',
        complemento: form.complemento || '',
        bairro: form.bairro || '',
        city: form.city || '',
        cityCode: form.cityCode || '',
        cep: form.cep || '',
        phone: form.phone || '',
        validade: form.validade || '',
        // enable：0停用 1启用
        enable: form.enable ? 1 : 0
      };
    },
    /** CNPJ 展示：接口返回的无符号 14 位 → 00.000.000/0000-00 */
    fmtCnpj(value) {
      return fmtCnpj(value);
    },
    /** ISO 时间 → MM-DD HH:mm:ss（表格「最后检查时间」展示） */
    fmtStamp(value) {
      if (!value) return '—';
      const d = new Date(value);
      if (isNaN(d.getTime())) return '—';
      const pad = n => String(n).padStart(2, '0');
      return `${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    },
    /** 点击查询：回到第 1 页重新拉接口；失败时不再提示命中条数（由 getTableData 统一报错） */
    async applyFilter() {
      this.searchParam.pageNumber = 1;
      this.searchParam.params.overallStatus = null;
      await this.getTableData();
    },
    /** 重置：所有筛选项回到默认值（关键词字段回到 CNPJ）并回到第 1 页 */
    async resetFilter() {
      this.searchParam.params = {
        kwType: 'cnpj', kw: '', uf: [], overallStatus: null, taxStatus: null, sysStatus: null, enable: null
      };
      this.searchParam.pageNumber = 1;
      await this.getTableData();
      // this.$message.info('已重置筛选条件 / Filtros redefinidos');
    },
    /** 看板 KPI 卡联动：按主体状态预筛（其余维度复位） */
    async prefilter(status = null, type = null) {
      if (type === 1) {
        this.searchParam.params = {
          kwType: 'cnpj', kw: '', uf: [], overallStatus: null, taxStatus: null, sysStatus: null, enable: status
        };
      } else if (type === 2) {
        this.searchParam.params = {
          kwType: 'cnpj', kw: '', uf: [], overallStatus: status, taxStatus: null, sysStatus: null, enable: null
        };
      }

      this.searchParam.pageNumber = 1;
      await this.getTableData();
    },

    // ============ 单元格渲染 ============
    /** 税务状态中文文案（有效 / 无效 / 未知 / 未录入） */
    taxText(tax) {
      return (TAX_LABEL[tax] || {}).zh || '—';
    },
    /** 税务状态葡语文案 */
    taxTextPt(tax) {
      return (TAX_LABEL[tax] || {}).pt || '—';
    },
    /** 税务状态标签配色：1有效绿 / 2无效红 / 3未知橙 / 4未录入灰 */
    taxTagCls(taxStatus) {
      const map = { 1: 'tag-ok', 2: 'tag-err', 3: 'tag-warn', 4: 'tag-gray' };
      return map[taxStatus] || 'tag-gray';
    },
    /** 系统配置状态中文文案（已配置 / 未配置） */
    sysText(sys) {
      return (SYS_LABEL[sys] || {}).zh || '—';
    },
    /** 系统配置状态葡语文案 */
    sysTextPt(sys) {
      return (SYS_LABEL[sys] || {}).pt || '—';
    },
    /** 剩余天数：优先取接口 daysLeft，缺失时按 validade 计算；未录入返回 null */
    expireDays(row) {
      if (typeof row.daysLeft === 'number') return row.daysLeft;
      return daysLeft(row.validade);
    },
    /** 有效期限配色：已过期红 / 到期提醒窗口内橙 / 其余常规色 */
    validadeCls(row) {
      const d = this.expireDays(row);
      if (d === null) return 'vd-normal';
      if (d < 0) return 'vd-expired';
      if (d <= this.expireWarnDays) return 'vd-soon';
      return 'vd-normal';
    },
    /** 有效期限剩余文案（中文）：已过期 N 天 / 剩 N 天；未录入返回空串 */
    validadeText(row) {
      const d = this.expireDays(row);
      if (d === null) return '';
      return d < 0 ? `已过期${Math.abs(d)}天` : `剩${d}天`;
    },
    /** 有效期限剩余文案（葡语）：vencido há N dias / N dias restantes */
    validadeTextPt(row) {
      const d = this.expireDays(row);
      if (d === null) return '';
      return d < 0 ? `vencido há ${Math.abs(d)} dias` : `${d} dias restantes`;
    },

    // ============ 操作 ============
    /** 导出当前筛选结果（演示阶段只提示条数） */
    handleExport() {
      getInvoiceSubjectStatusMonitorIEExport(this.queryConditions()).then(res => {
        if (res.code === 200) {
          goResourceTaskList();
        }
      });
    },
    /** 打开新增弹窗（表单清空、无当前行） */
    openAdd() {
      this.formMode = 'add';
      this.currentRow = null;
      this.formVisible = true;
    },
    /** 打开编辑弹窗；已启用监控的主体需先停用才能编辑 */
    handleEdit(row) {
      if (row.enable === 1) {
        this.$message.warning('该主体已启用监控，请先停用 / Esta entidade está com o monitoramento ativo; desative primeiro');
        return;
      }
      this.formMode = 'edit';
      this.currentRow = row;
      this.formVisible = true;
    },
    /** 新增 / 编辑保存：调新增 / 编辑接口，成功后刷新列表；失败只提示，不再本地写入 */
    async handleSave({ mode, form }) {
      const payload = this.toPayload(form);
      if (mode === 'edit') {
        const target = this.rows.find(x => x.id === form.id);
        payload.id = (target && target.id) || form.id || null;
      }
      const res = mode === 'add'
        ? await this.callApi('add', () => getInvoiceSubjectStatusMonitorIEAdd(payload))
        : await this.callApi('edit', () => getInvoiceSubjectStatusMonitorIEUpdate(payload));
      if (!res) {
        this.$message.error(`${form.uf} 保存失败，请稍后重试 / Falha ao salvar ${form.uf}`);
        return;
      }
      // fillStatus：FULL 税局字段全部取到 / PARTIAL 只取到部分
      const partial = res.data && res.data.fillStatus === 'PARTIAL';
      this.$message.success(partial
        ? `${form.uf} 已保存，税局仅返回部分字段，请核对 / ${form.uf} salvo; a SEFAZ retornou apenas parte dos campos`
        : `${form.uf} 已保存，系统将在 5 分钟内首次查询 / ${form.uf} salvo; primeira consulta em até 5 minutos`);
      await this.getTableData();
    },
    /** 点击启用开关：先弹二次确认，确认后才真正改 enable（0停用 1启用）并刷新检查时间 */
    handleToggleEnable(row) {
      const willEnable = row.enable !== 1;
      this.confirmOpts = {
        title: willEnable ? '启用监控' : '停用监控',
        titlePt: willEnable ? 'Ativar Monitoramento' : 'Desativar Monitoramento',
        subtitle: `${row.uf} · ${row.companyName}`,
        desc: willEnable
          ? '启用后该 IE 将加入定时检查队列（每日 <b>09:00 / 21:00</b>），并在状态异常时触发飞书告警。'
          : '停用后该 IE <b>不再参与定时查询与告警</b>，已记录的变更与历史日志将保留。',
        descPt: willEnable
          ? 'Após a ativação, esta IE entra na fila de verificação agendada (diariamente às 09:00 / 21:00) e dispara alertas no Feishu em caso de anomalia.'
          : 'Após a desativação, esta IE não participará das consultas agendadas nem dos alertas; as alterações registradas e o histórico serão mantidos.',
        okText: willEnable ? '确认启用' : '确认停用',
        okTextPt: willEnable ? 'Confirmar Ativação' : 'Confirmar Desativação',
        kind: willEnable ? 'ok' : 'warn',
        onOk: async() => {
          // 调启用 / 禁用接口（0停用 1启用）；成功后刷新该行，失败只提示不改数据
          const res = await this.callApi('toggle', () => getInvoiceSubjectStatusMonitorIEUpdateStatus({
            id: row.id,
            enable: willEnable ? 1 : 0
          }));
          if (!res) {
            this.$message.error(`${row.uf} 启停失败，请稍后重试 / Falha ao alterar ${row.uf}`);
            return;
          }
          await this.getTableData();
          this.$message.success(`${row.uf} 已${willEnable ? '启用' : '停用'}监控 / ${row.uf} ${willEnable ? 'ativado' : 'desativado'}`);
        }
      };
      this.confirmVisible = true;
    },
    /**
     * 点击「查看」：只用详情接口返回的数据渲染抽屉
     * 成功才打开抽屉，接口失败只提示，不再拿列表行数据兜底
     */
    async handleView(row) {
      if (!row.id) {
        this.$message.warning('该记录缺少主体 id，无法查询详情 / Registro sem id; não é possível consultar');
        return;
      }
      const res = await this.callApi('detail', () => getInvoiceSubjectStatusMonitorIEDetail(row.id));
      const data = res && res.data;
      if (!data) {
        this.$message.error(`${row.uf} 详情接口请求失败，请稍后重试 / Falha ao consultar detalhes de ${row.uf}`);
        return;
      }
      this.detailRow = data;
      this.detailUf = data.uf || row.uf;
      this.detailId = row.id;
      this.detailVisible = true;
      // 抽屉「近期变更」：按 UF 拉该州最近的变更记录
      this.fetchChangeLog(this.detailUf);
    },
    /** 抽屉「近期变更」：按 UF 查变更日志接口取最近 5 条；失败只提示，该区留空 */
    async fetchChangeLog(uf) {
      const param = {
        pageNumber: 1,
        pageSize: 5,
        // cnpj / ie / uf 均为数组格式（接口 List 入参），未筛选的传空数组
        params: { uf: uf ? [uf] : [], startTimeIso: null, endTimeIso: null, cnpj: [], ie: [], triggerType: null }
      };
      const res = await this.callApi('changeLog', () => getInvoiceSubjectStatusMonitorLogList(param));
      const ok = res && res.code === 200 && res.data && Array.isArray(res.data.items);
      this.detailChangeLog = ok ? res.data.items : [];
      if (!ok) this.$message.error('近期变更接口请求失败，请稍后重试 / Falha ao consultar alterações recentes');
    },
    /** 行内「查询」：触发该行所属州的单条查询 */
    handleQuery(row) {
      getInvoiceSubjectStatusMonitorIECheck(row).then(res => {
        if (res.code === 200) {
          this.$message.success(`已触发 ${row.uf} 单条查询 / Consulta individual de ${row.uf} disparada`);
          this.getTableData();
        }
      });
    },
    /** 抽屉底部的「单条查询」回调：查询接口由抽屉内部调用，这里只负责刷新列表 */
    handleQueryByUf() {
      this.getTableData();
    },
    /** 打开系统配置检索弹窗，传入当前行作为上下文 */
    openSysop(row) {
      this.currentRow = row;
      this.sysopVisible = true;
    },
    /** 检索弹窗回调：调「维护系统配置状态」接口，成功后刷新列表；失败只提示不改数据 */
    handleSysopUpdated() {
      this.getTableData();
    }
  }
};
</script>

<style scoped lang="scss">
.ie-manage {
  padding: 4px 0 20px;
}
.page-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  margin-bottom: 16px;
  gap: 16px;
}
.page-header h2 {
  font-size: 18px;
  font-weight: 600;
  display: flex;
  flex-direction: column;
}
.page-header h2 .h2-pt {
  font-size: 12px;
  font-weight: 400;
  color: #86909c;
}
.page-header .desc {
  color: #86909c;
  font-size: 12px;
  margin-top: 4px;
  display: flex;
  flex-direction: column;
}
.page-header .desc .desc-pt {
  font-size: 12px;
}
.page-header .right {
  display: flex;
  gap: 8px;
  flex-shrink: 0;
}

.filter-card {
  margin-bottom: 12px;
  border-radius: 8px;
}
.table-card {
  border-radius: 8px;
}

::v-deep .el-card__body { padding: 20px; }
::v-deep .el-form-item { margin-bottom: 0; }
::v-deep .el-form-item__label { padding-bottom: 4px; line-height: 20px; }
.ph-label { display: block; }
/* 关键词：label 处的字段下拉做成「无边框标签下拉」（同 CTE 发票密钥 / 运单号） */
::v-deep .kw-search .el-form-item__label {
  width: 100%;
  padding-bottom: 2px;
}
::v-deep .kw-search .el-form-item__label .el-select { width: 100%; }
::v-deep .kw-search .el-form-item__label .el-input--small .el-input__inner {
  border: none;
  padding-left: 0;
  height: 26px;
  line-height: 26px;
  font-weight: 600;
  color: #1d2129;
  background: transparent;
}
::v-deep .kw-search .el-form-item__label .el-input__suffix { right: 0; }
::v-deep .filter-btns .el-form-item__content { display: flex; }
.opt-pt {
  font-size: 14px;
}

::v-deep .cell-num .cell {
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 14px;
}
::v-deep .el-table th .cell { line-height: 1.35; }

.tag {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 8px;
  font-size: 12px;
  font-weight: 500;
  border-radius: 4px;
  line-height: 18px;
  white-space: nowrap;
}
.tag .dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: currentColor;
}
.tag .tag-pt {
  font-size: 12px;
  font-weight: 400;
}
.tag-ok { background: #e8f7e9; color: #00b42a; }
.tag-err { background: #ffecec; color: #f53f3f; }
.tag-warn { background: #fff3e0; color: #ff7d00; }
.tag-info { background: #e6f0ff; color: #165dff; }
.tag-gray { background: #f2f3f5; color: #4e5969; }

.vd-empty {
  color: #c9cdd4;
  font-style: italic;
}
.vd-empty .vd-pt,
.vd-days {
  font-style: normal;
  font-size: 12px;
}
.vd-expired {
  color: #f53f3f;
  font-weight: 600;
}
.vd-soon {
  color: #ff7d00;
  font-weight: 600;
}
.vd-normal {
  font-family: ui-monospace, 'SF Mono', Menlo, Consolas, monospace;
  font-size: 12px;
}
.vd-pt {
  display: block;
  font-size: 12px;
  font-weight: 400;
  color: #86909c;
}

.sys-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
  align-items: flex-start;
}
.sys-link {
  color: #00a551;
  font-size: 12px;
  cursor: pointer;
}
.sys-link .sys-pt {
  font-size: 12px;
}
::v-deep .sys-cell .el-button--mini {
  padding: 3px 8px;
  font-size: 12px;
}
::v-deep .sys-cell .el-button--mini .sys-pt {
  font-size: 12px;
}

/* 启用开关统一使用 ToggleSwitch 组件（点击只抛事件，状态由数据驱动） */
.act-group {
  display: flex;
  gap: 8px;
  align-items: center;
}
.act-group a {
  font-size: 12px;
  cursor: pointer;
  white-space: nowrap;
}
.act-group a .act-pt {
  font-size: 12px;
}
.act-group a.act-view { color: #4e5969; }
.act-group a.act-view:hover { color: #00a551; }
.act-group a.act-edit { color: #4e5969; }
.act-group a.act-edit:hover { color: #00a551; }
.act-group a.act-edit.disabled {
  color: #c9cdd4;
  cursor: not-allowed;
}
.act-group a.act-edit.disabled:hover { color: #c9cdd4; }

.empty-row {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding: 32px 12px;
  color: #86909c;
  font-size: 14px;
}
.empty-row .empty-pt {
  font-size: 14px;
}

/* 分页：el-pagination（总数走自定义 slot，保留中葡双语） */
.ie-pagination {
  padding: 14px 0 2px;
  font-size: 12px;
  color: #4e5969;
}
.pb-total {
  display: flex;
  flex-direction: column;
  font-weight: 400;
  line-height: 1.35;
}
.pb-total .pb-pt {
  font-size: 12px;
  color: #86909c;
}
::v-deep .ie-pagination .el-pagination__sizes { margin: 0 8px 0 12px; }
::v-deep .ie-pagination .btn-prev,
::v-deep .ie-pagination .btn-next,
::v-deep .ie-pagination .el-pager li,
::v-deep .ie-pagination .el-input__inner,
::v-deep .ie-pagination .el-input .el-input__inner,
{
  background: #fff;
  border: 1px solid #e5e6eb;
  border-radius: 4px;
  min-width: 28px;
  height: 28px;
  line-height: 26px;
  margin: 0 3px;
  font-weight: 400;
}
::v-deep .ie-pagination .el-pager li.active {
  background: #00a551;
  border-color: #00a551;
  color: #fff;
}
::v-deep .ie-pagination .el-pagination__jump { margin-left: 8px; }

</style>
